module.exports = __webpack_public_path__ + "static/media/HardDrive.c8704991.svg";